import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Background, Foreground } from '@front/sharedcomponents/Styles';
import { Size } from '@front/sharedcomponents/Variables';
import { Resources } from '@shared/localizations/Resources';
import { SortingDirection } from '@shared/utils/Table/TableSortingRules.interface';
import { useTableHeaderCell } from './useTableHeaderCell';
import { SvgIcon } from '../../SvgIcon/SvgIcon';
import { SvgIconType } from '../../SvgIcon/SvgIconType';
import { Typography } from '../../Typography/Typography';
import { TypographyLevel } from '../../Typography/TypographyLevel';
import { ColumnAlignmentStyles } from '../Table.interface';
export const TableHeaderCell = ({ isGroupColumn = false, isAllowResizeSeparator = true, isColumnsResizing = false, column, width, sorting = SortingDirection.None, ref, onClick, onDragStart, onDragMove, onDragEnd, onResizeStart, onResizeMove, onResizeEnd }) => {
    const { handleMouseDown, handleClick, handleResizeMouseDown } = useTableHeaderCell({
        column,
        isGroupColumn,
        onClick,
        onDragStart,
        onDragMove,
        onDragEnd,
        onResizeStart,
        onResizeMove,
        onResizeEnd
    });
    const renderSortingIcon = () => {
        if (sorting === SortingDirection.None) {
            return null;
        }
        return (_jsx(SvgIcon, { className: Size.XS, icon: sorting === SortingDirection.Ascending ? SvgIconType.SortUp : SvgIconType.SortDown }));
    };
    const className = [
        'table-head-cell',
        Background.Secondary,
        Foreground.Hint,
        ColumnAlignmentStyles[column.alignment],
        isColumnsResizing ? 'resizing' : ''
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("th", { ref: ref, className: className, style: { flex: width }, scope: "col", "data-testid": column.id, onClick: handleClick, onMouseDown: handleMouseDown, tabIndex: 0, children: [_jsx(Typography, { level: TypographyLevel.BodySm, noWrap: true, children: Resources.getResource(column.localizationKey) }), renderSortingIcon(), isAllowResizeSeparator && (_jsx("div", { className: "table-head-cell-resizer", "aria-hidden": true, onMouseDown: handleResizeMouseDown }))] }));
};
